<template>
    <div class="PersonnelBox">
        <span>发布人：</span>
        <span >{{ data.fbr || '无' }}</span>
        <span style="margin-left: 20px;">审核人：</span>
        <span >{{ data.shr1 || '无' }}</span>
    </div>
</template>
  
<script>
import { fileName } from "@/utils";
import "@/assets/less/details-box.less";
export default {
    props: ["data"],
    data() {
        return {
            fileName,
        };
    },
};
</script>
  
<style lang="less" scoped>
.PersonnelBox {
    // width: 1200px;
    margin-top: 14px;
    font-size: 14px;
    color: rgba(16, 16, 16, 1);
    width: 1057px;
    height: 50px;
    display: flex;
    align-items: center;
    background-color: rgba(247, 247, 247, 1);
    padding-left: 18px;
    flex-wrap: wrap;
}
</style>